"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ripple_1 = require("../utils/ripple");
var ACCard = function (props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(Array.isArray(props === null || props === void 0 ? void 0 : props.handlers) && ((_a = props === null || props === void 0 ? void 0 : props.handlers) === null || _a === void 0 ? void 0 : _a.length) ? 'clickable ripple-effect' : '', " apx-ui_card ").concat(props.className), onClick: function (e) {
            (0, ripple_1.createRipple)(e);
            e.stopPropagation();
            (props === null || props === void 0 ? void 0 : props.onClick) && props.onClick();
        }, children: props === null || props === void 0 ? void 0 : props.renderFields(props === null || props === void 0 ? void 0 : props.fields) }));
};
exports.ACCard = ACCard;
